import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing

// style
const style = css`
    ${mixin.row2}

	> .stats {
        > article {
            padding: 20px 0;
            text-align: center;
            .iconBadge {
                ${mixin.iconBadge}
            }
            > h4 {
                font-size: 24px;
            }
        }
    }

    > .soh {
        > h3 {
        }
    }
`;

// component
export class DevicesSummary extends Proto<Props, State> {

    parseGraphData( ) {
        const { data } = this.state;
        return (data.soh || []).map( v => {
            let color = vars.colors.red;
            if (v.from > 20) color = vars.colors.yellow;
            if (v.from > 45) color = vars.colors.green;
            const label = `${v.from}-${v.to}%`;
            return {
                ...v,
                label,
                color
            };
        });
    }
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const config = {
            "type": "serial",
            "theme": "light",
            "graphs": [{
                "type": "column",
                "fillColorsField": "color",
                "fillAlphas": 0.9,
                "lineAlpha": 0.2,
        
                "valueField": "val"
            }],
            "valueAxes": [{
                "axisAlpha": 0,
                "position": "bottom",
                "title": "Batteries"
            }],
            "rotate": true,
            "categoryField": "label",
            "dataProvider": this.parseGraphData()
        };
      
		return (
            <Box title={_('devicessummary_title', 'Dash')} collapsed={false}>
                <div className={style}>
                    <section className="stats">
                        <article>
                            <span className="iconBadge">
                                <i className="icon-battery" />
                                <strong>{data.count_connected}</strong>
                            </span>
                            <h4>{_('devicessummary_title_devices', 'Dash')}</h4>
                        </article>
                        <article>
                            <span className="iconBadge">
                                <i className="fa fa-users" />
                                <strong>{data.count_customers}</strong>
                            </span>
                            <h4>{_('devicessummary_title_customers', 'Dash')}</h4>
                        </article>
                    </section>
                    <section className="soh">
                        <h3>{_('devicessummary_title_soh', 'Dash')}</h3>
                        <AmCharts.React style={{ width: "100%", height: "400px" }} options={config} />
                    </section>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Dash/DevicesSummary.tsx